module.exports = __webpack_public_path__ + "static/media/img_phone-light-full.ff76a7e4.png";